/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import {
  renderBarChart,
  renderLineChart,
  renderPieChart,
  renderMapChart,
} from './charts';
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wp-block-blocks-d3').forEach((el) => {
    const config = JSON.parse(el.dataset.chart);
    switch (config.chartType) {
      case 'bar':
        renderBarChart(el, config);
        break;
      case 'line':
        renderLineChart(el, config);
        break;
      case 'pie':
        renderPieChart(el, config);
        break;
      case 'map':
        renderMapChart(el, config);
        break;
      default:
        console.log('Chart type not supported');
        break;
    }
  });
});
